import { ColumnConfig } from '@components/design/migrated/Table';
import { ColumnHeaderDisplayNameForPA, ColumnHeaderForPA } from '@models/PerformanceAnalysisboard';
import { ShareType } from '@utils/pageConfig/Types';
import { sortFields } from '@utils/TableUtils';

const commonColumnFields = {
  className: 'z-20',
  isSortable: true,
  sortFields,
  compact: true,
};

const getBaseColumns = (selectedShareType: ShareType, volume: string) => ({
  [ColumnHeaderForPA.marketRetailerRevenueShare]: ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.marketRetailerRevenueShare],
  [ColumnHeaderForPA.marketRetailerVolumeShare]: ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.marketRetailerVolumeShare],
  [ColumnHeaderForPA.marketRevenue]: ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.marketRevenue],
  [ColumnHeaderForPA.marketExcludeRetailRevenue]: ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.marketExcludeRetailRevenue],
  [ColumnHeaderForPA.marketVolume]: ColumnHeaderDisplayNameForPA(volume)[ColumnHeaderForPA.marketVolume],
  [ColumnHeaderForPA.marketExcludeRetailVolume]: ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.marketExcludeRetailVolume],
  [ColumnHeaderForPA.yourRevenue]: ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.yourRevenue],
  [ColumnHeaderForPA.yourRevenueShare]: selectedShareType === ShareType.MarketShare
      ? ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.yourRevenueShare]
      : ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.yourRevenueMix],
  [ColumnHeaderForPA.yourVolume]: ColumnHeaderDisplayNameForPA(volume)[ColumnHeaderForPA.yourVolume],
  [ColumnHeaderForPA.yourVolumeShare]: selectedShareType === ShareType.MarketShare
      ? ColumnHeaderDisplayNameForPA(volume)[ColumnHeaderForPA.yourVolumeShare]
      : ColumnHeaderDisplayNameForPA(volume)[ColumnHeaderForPA.yourVolumeMix],
  [ColumnHeaderForPA.marketPrice]: ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.marketPrice],
  [ColumnHeaderForPA.marketExcludeRetailPrice]: ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.marketExcludeRetailPrice],
  [ColumnHeaderForPA.yourPrice]: ColumnHeaderDisplayNameForPA()[ColumnHeaderForPA.yourPrice],
});

const buildColumns = (selectedShareType: ShareType, volume: string, columnOrder: string[]): ColumnConfig[] => {
  const baseColumns = getBaseColumns(selectedShareType, volume);
  return columnOrder.map((headerKey) => ({
    headerKey,
    name: baseColumns[headerKey],
    ...commonColumnFields,
  }));
};

export const getPerformanceAnalysisboardColumns = (selectedShareType: ShareType, volume: string): ColumnConfig[] =>
    buildColumns(selectedShareType, volume, [
      ColumnHeaderForPA.marketRetailerRevenueShare,
      ColumnHeaderForPA.marketRetailerVolumeShare,
      ColumnHeaderForPA.marketRevenue,
      ColumnHeaderForPA.marketExcludeRetailRevenue,
      ColumnHeaderForPA.marketVolume,
      ColumnHeaderForPA.marketExcludeRetailVolume,
      ColumnHeaderForPA.yourRevenue,
      ColumnHeaderForPA.yourRevenueShare,
      ColumnHeaderForPA.yourVolume,
      ColumnHeaderForPA.yourVolumeShare,
      ColumnHeaderForPA.marketPrice,
      ColumnHeaderForPA.marketExcludeRetailPrice,
      ColumnHeaderForPA.yourPrice,
    ]);

export const getPerformanceAnalysisboardColumnsForExcelExport = (selectedShareType: ShareType, volume: string): ColumnConfig[] =>
    buildColumns(selectedShareType, volume, [
      ColumnHeaderForPA.marketRetailerRevenueShare,
      ColumnHeaderForPA.marketRetailerVolumeShare,
      ColumnHeaderForPA.marketRevenue,
      ColumnHeaderForPA.marketExcludeRetailRevenue,
      ColumnHeaderForPA.marketVolume,
      ColumnHeaderForPA.yourRevenue,
      ColumnHeaderForPA.yourRevenueShare,
      ColumnHeaderForPA.marketExcludeRetailVolume,
      ColumnHeaderForPA.yourVolume,
      ColumnHeaderForPA.yourVolumeShare,
      ColumnHeaderForPA.marketPrice,
      ColumnHeaderForPA.marketExcludeRetailPrice,
      ColumnHeaderForPA.yourPrice,
    ]);
